import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RootLayout } from "../layout/root-layout";
import { Books } from "../views/books";
import { Contact } from "../views/contact";
import { About2 } from "../views/about2";

export const AppRouter = () => (

    <BrowserRouter>
        <Routes>
            <Route path="/" element={<RootLayout />}>
                <Route index element={<About2 />} />
                <Route path="/about" element={<About2 />} />
                <Route path="/cv" element={<Contact />} />
                <Route path="/books" element={<Books />} />
            </Route>
        </Routes>
    </BrowserRouter>
)
